/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2026-01-26 14:40:39
 */
import React from 'react'
import classNames from 'classnames'
import { MEMBER_CONFIG } from '../constants'
import CONFIG from '../../../constants/config'
import { useButtonText, useVipTypeDisabled } from '../hooks'
import { usePayment } from '../../../app/hooks'

const FIXED_MEMBERS_DATA = [
  ...MEMBER_CONFIG,
  {
    title: '企业级',
    price: 167,
    priceSuffix: '元/月起',
    buttonText: '立即咨询',
    vipKind: CONFIG.VIP_KIND.EVIP
  }
]

const FixedMemberCard = ({
  member,
  handleEventTrack
}: {
  member: any
  handleEventTrack: (clickItem: string, vipKind?: number) => void
}) => {
  const { openVipByKind } = usePayment()
  const disabled = useVipTypeDisabled(member)
  const buttonText = useButtonText(member)

  const handleButtonClick = () => {
    let clickItem = '开通或升级'
    if (member.vipKind === CONFIG.VIP_KIND.EVIP) {
      clickItem = '点击企业级会员'
    }
    handleEventTrack(clickItem, member.vipKind)
    openVipByKind(member.vipKind, 'webVIPSummary')
  }

  if (member.vipKind === 0) {
    return (
      <div className="memberCol">
        <div className="memberCard"></div>
      </div>
    )
  }

  return (
    <div className="memberCol">
      <div
        className={classNames('memberCard', {
          memberCardDisabled: disabled
        })}
      >
        <div className="cardHeader">
          <div className="cardTitle">{member.title}</div>
          <div className="cardPrice">
            <span className="priceValue">{member.price}</span>
            <span className="priceSuffix">{member.priceSuffix}</span>
          </div>
          <button
            className="cardButton"
            disabled={disabled}
            onClick={handleButtonClick}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default function FixedMembers({
  style,
  handleEventTrack
}: {
  style?: React.CSSProperties
  handleEventTrack: (clickItem: string, vipKind?: number) => void
}) {
  return (
    <div className="fixedMembers" style={style}>
      <div className="fixedContent">
        {FIXED_MEMBERS_DATA.map((member, index) => (
          <FixedMemberCard
            key={index}
            member={member}
            handleEventTrack={handleEventTrack}
          />
        ))}
      </div>
    </div>
  )
}
